import styled from 'styled-components';

export const BtnBack = styled.div`
width:200px;
position:fixed;
bottom:25px;
z-index:9;
left:calc(50vw - 100px);
`